<template>  
    <vuescroll>
      <div class="box-border m-8">
          <Header>
              <template v-slot:title>Contactame</template>
              <template v-slot:subtitle>deja un mensaje</template>
          </Header>
          <div class="box-border block w-full text-center">
            <span class="text-4xl">Envíame un <a class="font-bold underline" :href="`mailto:${data.email}`">correo electrónico</a> o comunícate conmigo en las redes sociales</span>
            <ul>
              <li v-for="(media, index) in data.social" :key="index" class="inline-block p-2 group text-tertiary"><a :href="media.url" target="_blank" rel="noopener noreferrer" class="group-hover:font-black">{{ media.name }}</a></li>
            </ul>
          </div>
      </div>
    </vuescroll>
</template>

<script>
import vuescroll from "vuescroll";
import Header from "../components/Header.vue";
import data from "../data/contact"

export default {
  components: {
    vuescroll,
    Header,
  },
  data() {
    return {
      data: data
    }
  }
};
</script>

<style></style>
